export default __webpack_public_path__ + "static/media/Layout t2 - Segregação Arm.06 rev 13.c9f6c651.pdf";